// eslint disabled because importing this library only stores the api on the document object, not as a direct export.
// eslint-disable-next-line no-unused-vars
import * as pricingContextLibrary from '@vp/pricing-context-module';
import pricingContextModuleHelpers from '@vp/pricing-context-module/helpers';
import {
  // trackError,
  trackPricingContextNotAvailable,
} from './newRelicTrackingApi';

/*
 * A variable used as a queue for functions we need to run after the pricing
 * context is available on the page.
 */
const pricingContextQueue = [];

/**
 * Initialization function of the Pricing Context Module using the module helper.
 * @param {*} merchantId The OM merchantId to use as an inbound parameter for initialization.
 * @param {*} country The OM Country code to use as an inbound parameter for initialization.
 *
 * both of these are configured in site-config
 * merchantId : pricingOptions: { merchantId }
 * country: country
 */
export const initializePricingContextModule = (merchantId, country) =>
  new Promise(resolve => {
    pricingContextModuleHelpers.initializePricingContext(
      {
        merchantId,
        market: country,
        isDevelopmentMode: process.env.NODE_ENV !== 'production',
      },
      // callback function from the pricing context module
      pricingContext => {
        // if we enqueued any functions, run them now that the pcxt module is initialized
        pricingContextQueue.forEach(() => {
          const fn = pricingContextQueue.shift();
          fn();
        });
        // resolve the promise, allows us to determine that pricing context is initialized
        resolve(pricingContext);
      }
    );
  });

/**
 */
export async function orderPlaced(tenant, shopperId) {
  const pricingContextModule =
    typeof document !== 'undefined' && document && document.pcxtV3;

  if (!pricingContextModule || !pricingContextModule.isInitialized()) {
    // if the pricing context isn't available, queue up this call to orderPlaced, this
    // ensures the call isn't executed before the initialization of the pcxtv3 has happened
    pricingContextQueue.push(() => {
      pricingContextModule.orderPlaced();
    });
    trackPricingContextNotAvailable(
      new Error(
        'Pricing Context Module not available, call to orderPlaced before PCTX initialiazed'
      ),
      shopperId,
      tenant
    );
    return;
  }

  try {
    await pricingContextModule.orderPlaced();
  } catch (error) {
    // trackError({ error, tenant });
    console.error(
      'Error calling pricing context module orderPlaced method',
      error
    );
  }
}
